<template>
  <div class="wrapper">
    <div class="inner" v-if="isShow">
      <div class="tabs-wrapper">
        <div
          v-for="(item, index) of tabList"
          :key="index"
          @click="clickSingle(item,index) "
          :class="['tab', tabSelectIndex === index ? 'tab-selected' : '']"
        >
          <div class="item-r">
            <div class="item-v">
              <span :class="['tabT', tabSelectItem === item ? 'tabT-selected' : '']">{{item}}</span>
              <div :class="['tabB', tabSelectItem === item ? 'tabB-selected' : '']"></div>
            </div>
            <img class="tip-icon-t"
            @click="showTips"
            src="../assets/warn-tip-gray.png"
            v-if="showItip(pcData, item)" />
          </div>
        </div>
      </div>

      <PeriodIncrease ref="PeriodIncrease" v-if="tabSelectItem === '阶段涨幅'" />
      <NetList ref="NetList" v-if="tabSelectItem === '历史净值'" />
      <FixIncomeList v-if="tabSelectItem === '定投收益'" />
      <NetSevenDayList ref="NetSevenDayList" v-if="tabSelectItem === '历史7日年化'" />
      <div class="bottomSPView"></div>
    </div>
  </div>
</template>
<script>
import JS from '@/base/JSTool';

import PeriodIncrease from '@/components/Mark-Period-Increase.vue';
import NetList from '@/components/Mark-Netlist.vue';
import StoreManger from '@/utils/FundHQJHManger';
import FixIncomeList from '@/components/Mark-FixList.vue';
import NetSevenDayList from '@/components/Mark-NetSevenDayList.vue';
import FundTypeSearch from '@/utils/FundTypeSearch';

export default {
  name: 'market',
  components: {
    PeriodIncrease,
    NetList,
    FixIncomeList,
    NetSevenDayList,
  },
  props: {},
  watch: {},
  data() {
    return {
      isShow: false,
      pageData: {},
      tabList: ['阶段涨幅', '历史净值', '定投收益'],
      tabSelectIndex: 0,
      tabSelectItem: '阶段涨幅',
      nativeData: {},
      fundCode: '',
      fundType: '',
      pcData: {},
    };
  },
  computed: {
    isExchangeFund() {
      return FundTypeSearch.isExchangeFund(this.fundType);
    },
    isNewFund() {
      return FundTypeSearch.isNewFund(this.fundType);
    },
    isMonetaryfund() {
      return FundTypeSearch.isMonetaryfund(this.fundType);
    },
  },
  created() {
    this.handleDetail();
  },
  mounted() {},
  methods: {
    render() {
      const fundinfo = StoreManger.getFundJJXQ();
      if (!fundinfo) {
        this.mainQueryError();
        return;
      }
      this.pcData = StoreManger.getFundJDZF();
      this.handleData();
      const refs = this.$refs;
      if (!this.isNewFund) {
        if (refs.PeriodIncrease) {
          refs.PeriodIncrease.render();
        }
        if (refs.NetList) {
          refs.NetList.render();
        }
        if (refs.NetSevenDayList) {
          refs.NetSevenDayList.render();
        }
      }
    },
    handleDetail() {
      this.handleData();
    },
    handleData() {
      this.fundCode = this.$store.state.native.fund.fundCode;
      this.fundType = this.$store.state.native.fund.fundType;

      this.show();
      if (this.isNewFund) {
        this.isShow = false;
      }
      if (this.isExchangeFund) {
        this.tabList = ['阶段涨幅', '历史净值'];
      }
      if (this.isMonetaryfund) {
        this.tabList = ['阶段涨幅', '历史7日年化'];
      }
      const fundinfo = StoreManger.getFundJJXQ();
      this.pageData = fundinfo;
      const fetch = (key) => {
        const res = JS.fetchString(this.pageData, key);
        return res || '--';
      };
      const fundType = fetch('FUNDTYPE');
      const bFundType = fetch('BFUNDTYPE');
      // 净值型货币理财
      if (fundType === '205') {
        if (bFundType === '004') {
          this.tabList = ['阶段涨幅', '历史净值'];
        } else if (bFundType === '005') {
          this.tabList = ['阶段涨幅', '历史净值'];
        }
      }
    },
    showItip(item, select) {
      if (!item) {
        return false;
      }
      if (!item.Datas) {
        return false;
      }
      let show = false;
      if (select === '阶段涨幅') {
        if (item) {
          if (item) {
            const newList = item.Datas.slice(0, 5);
            newList.forEach((el) => {
              if (el.syl === '') {
                show = true;
              }
            });
          }
        }
      }
      return show;
    },
    clickSingle(item, index) {
      this.tabSelectItem = item;
      this.tabSelectIndex = index;
      setTimeout(this.reflashListData, 300);
      if (item === '阶段涨幅') {
        this.reportMonitor({
          eventName: 'pz.middle.jdzf',
        });
      }
      if (item === '历史净值') {
        this.reportMonitor({
          eventName: 'pz.middle.lsjz',
        });
      }
      if (item === '定投收益') {
        this.reportMonitor({
          eventName: 'pz.middle.dtsy',
        });
      }
    },
    mainQueryError() {
      const refs = this.$refs;
      Object.keys(refs)
        .forEach((key) => {
          const ref = refs[key];
          if (ref) {
            if (ref.mainQueryError) {
              ref.mainQueryError();
            }
          }
        });
    },
    reflashListData() {
      const fundinfo = StoreManger.getFundJJXQ();
      if (!fundinfo) {
        this.mainQueryError();
        return;
      }
      const refs = this.$refs;
      Object.keys(refs)
        .forEach((key) => {
          const ref = refs[key];
          if (ref) {
            if (ref.render) {
              ref.render();
            }
          }
        });
    },
    showTips() {
      this.$feedback.showModal({
        title: '温馨提示',
        content: '当前基金阶段收益以收盘净值计算',
        confirmText: '知道了',
        confirmColor: '#f40',
        showCancel: false,
      });
    },
    show() {
      this.isShow = true;
    },
  },
};
</script>
<style lang="less" scoped>
.wrapper{
  padding-left: 24px;
  padding-right: 24px;
  margin-bottom: 24px;
  border-radius: 12px;
}
.inner {
  background-color: #ffffff;
  border-radius: 12px;
  margin-bottom: 4px;
  padding-top: 12px;
}
.tabs-wrapper {
  display: flex;
  height: 88px;
  border-radius: 12px;
  justify-content: space-between;
}
.tip-icon-t {
  height: 24px;
  width: 24px;
  margin-left: 10px;
  padding-bottom: 0px;
  margin-top: -8px;
}
.tab {
  display: flex;
  flex: 1;
  font-family: PingFangSC-Regular;
  font-size: 32px;
  color: #333;
  letter-spacing: 0;
  text-align: center;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.tab-selected {
  color: #000;
  font-weight: bold;
}
.tabT {
  font-family: PingFangSC-Regular;
  font-size: 32px;
  color: #333;
}
.tabT-selected {
  color: #000;
  font-weight: bold;
}
.tabB {
  position: relative;
  top: 10px;
  width: 30px;
  height: 6px;
  border-radius: 3px;
}
.tabB-selected {
  background-color:#ff4400;
}
.item-r{
  display: flex;
  text-align: center;
  align-items: center;
  flex-direction: row;
  justify-content: center;
}
.item-v{
  position: relative;
  display: flex;
  flex: 1;
  text-align: center;
  align-items: center;
  flex-direction: column;
  justify-content: center;
}
.bottomSPView{
  height: 8px;
}
</style>
